import {
  WbDrawer,
  WbDrawerContent,
  WbDrawerProps,
} from '@agilelab/plugin-wb-platform';
import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  drawerContent: {
    gap: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const DetailDrawer = (props: WbDrawerProps) => {
  const { ...drawerProps } = props;
  const classes = useStyles();

  return (
    <WbDrawer {...drawerProps}>
      <WbDrawerContent className={classes.drawerContent}>
        {props.children}
      </WbDrawerContent>
    </WbDrawer>
  );
};
